import React, {useState} from "react";
import {
  Box,
  Button,
  Flex,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Stack,
  Text
} from "@chakra-ui/react";
import {event} from "../../../../services/analytics";
import {DatabaseInfo} from "@app/core-app/app/data/notion/DatabaseInfo";


function ConnectRecipientsDatabaseModal({isOpen, onClose, databases, onDatabaseSelected}: {
    isOpen: boolean;
    onClose: () => void;
    databases: DatabaseInfo[];
    onDatabaseSelected: (newDatabase: DatabaseInfo) => Promise<any>
}) {
  const [loading, setLoading] = useState(false)
  const handleSave = (database: DatabaseInfo) => {
    setLoading(true)
    onDatabaseSelected(database)
      .then(() => {
        onClose();
      });
  };

  //   Sort databases to have configured at the top of the list
  const sortedDatabases = [...databases]
  sortedDatabases.sort((a, b) => {
    if (a.recipientsConfig.result === "ok" && b.recipientsConfig.result !== "ok") {
      return -1;
    }
    if (a.recipientsConfig.result !== "ok" && b.recipientsConfig.result === "ok") {
      return 1;
    }
    return 0;
  })

  return (
    <Modal isOpen={isOpen} onClose={onClose} size={"2xl"} scrollBehavior={"inside"}>
      <ModalOverlay/>
      <ModalContent minH={"75vh"}>
        <ModalHeader>Connect Recipients Database</ModalHeader>

        <ModalCloseButton/>
        <ModalBody>
          <Stack spacing={4} mb={8}>
            <Stack>
              <Text>Select Notion database to use as list of recipients for all outgoing emails</Text>
              <Text>Database must have properties "Email" and "Subscribed" to work with Outbox.</Text>
            </Stack>
            {sortedDatabases.map((db) => {
              return <Box key={db.id}
                border={"1px solid"}
                borderColor={"gray.300"}
                rounded={"md"} py={4} px={4}
                shadow={"sm"}
              >
                <Flex justifyContent={"space-between"} alignItems={"center"}>
                  <Text fontSize={"xl"}>{db.name}</Text>
                  <Button size={"sm"} colorScheme={"blue"} variant={"outline"}
                    isLoading={loading}
                    onClick={() => {
                      handleSave(db)
                    }}>
                      <span>Connect</span>
                  </Button>
                </Flex>

                <Stack spacing={0.5} fontSize={"sm"} my={2}>
                  <Text fontWeight={"medium"}>Configuration status:</Text>
                  <Stack direction={"row"} spacing={1}>
                    <Text>Ready to use: </Text>
                    <Text>{db.recipientsConfig.result === "ok" ? "Yes": "No"}</Text>
                  </Stack>
                  <Stack direction={"row"} spacing={1}>
                    <Text>Email property available: </Text>
                    <Text>{db.recipientsConfig.email.ok ? "Yes": "No"}</Text>
                  </Stack>
                  <Stack direction={"row"} spacing={1}>
                    <Text>Subscribed property available: </Text>
                    <Text>{db.recipientsConfig.subscription.ok ? "Yes": "No"}</Text>
                  </Stack>
                </Stack>
              </Box>
            })}
          </Stack>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}

export function ConnectRecipientsDatabase({databases, onDatabaseSelected}: {
    databases: DatabaseInfo[];
    onDatabaseSelected: (newDatabase: DatabaseInfo) => Promise<any>
}) {
  const [isOpen, setIsOpen] = useState(false);

  const handleOpenModal = () => {
    event({action: "open_connect_recipients_modal", params: {}})
    setIsOpen(true);
  };

  const handleCloseModal = () => {
    setIsOpen(false);
  };

  return (
    <>
      <Button size="sm" colorScheme="blue" variant={"outline"} onClick={handleOpenModal}>
                <span>Connect Recipients Database</span>
      </Button>
      <ConnectRecipientsDatabaseModal isOpen={isOpen}
        onClose={handleCloseModal}
        databases={databases}
        onDatabaseSelected={onDatabaseSelected}
      />
    </>
  );
}
